import type { NextPage } from 'next'
import { MyDesignServices } from '@/client/modules/MyOrders/MyDesignServices'
import { IMyAccount } from '@/client/modules/MyOrders/types'
import { getCMSContent } from '@/client/utils'
import { IRoutes } from '@/client/utils/routes/types'

const MyDesignServicesPage: NextPage<IMyAccount> = (data) => <MyDesignServices {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, IRoutes.MY_ACCOUNT)

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default MyDesignServicesPage
